import { Dropdown } from 'react-bootstrap';

const filterBtnStyle = {
    height: '24px',
    minHeight: '24px',
    padding: '0 8px',
    lineHeight: '1',
};

type FilterOption = {
    value: string;
    label: string;
};

const WarehouseSelectHeader = ({
    title,
    hideFilter = false,
    warehouseTypeFilter,
    setWarehouseTypeFilter,
    t
}: any) => {
    const options: FilterOption[] = [
        { value: 'all', label: t('warehouseFilterAll') },
        { value: 'main', label: t('warehouseFilterMain') },
        { value: 'team', label: t('warehouseFilterTeams') },
        { value: 'object', label: t('warehouseFilterObjects') },
        { value: 'reserve', label: t('warehouseFilterReserve') },
    ];

    const activeLabel =
        options.find((opt) => opt.value === warehouseTypeFilter)?.label ||
        t('warehouseFilterAll');

    return (
        <div className="d-flex align-items-center justify-content-between gap-2 mb-1">
            <label className="form-label text-muted mb-0 text-truncate">{title}</label>

            {!hideFilter && (
                <>
                    <Dropdown align="end" className="d-md-none flex-shrink-0">
                        <Dropdown.Toggle
                            size="sm"
                            variant="outline-primary"
                            className="warehouse-type-filter-dropdown"
                            style={filterBtnStyle}
                            id="warehouse-type-filter-mobile"
                        >
                            {activeLabel}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            {options.map((opt) => (
                                <Dropdown.Item
                                    key={opt.value}
                                    active={warehouseTypeFilter === opt.value}
                                    onClick={() => setWarehouseTypeFilter(opt.value)}
                                >
                                    {opt.label}
                                </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>

                    <div
                        className="btn-group btn-group-sm d-none d-md-inline-flex flex-shrink-0"
                        role="group"
                        aria-label={t('warehouseTypeFilter')}
                    >
                        {options.map((opt) => (
                            <button
                                key={opt.value}
                                type="button"
                                className={`btn ${
                                    warehouseTypeFilter === opt.value
                                        ? 'btn-primary'
                                        : 'btn-outline-primary'
                                }`}
                                onClick={() => setWarehouseTypeFilter(opt.value)}
                                style={filterBtnStyle}
                            >
                                {opt.label}
                            </button>
                        ))}
                    </div>
                </>
            )}
        </div>
    );
};

export default WarehouseSelectHeader;
